import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getpressAPi, createpressAPi,  uploadpressAPi, deletepressApi } from "../../../ApiUrl";
import { toast } from "react-toastify";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create press
export const createpress = createAsyncThunk('createpress/press', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createpressAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatepress = createAsyncThunk('updatepress/press', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadpressAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get press
export const getpress = createAsyncThunk('getpress/press', async () => {
    try {
        const response = await axios.get(`${getpressAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'presss' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete press
export const deletepresss = createAsyncThunk('deletepresss/press', async (pressid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletepressApi}/${pressid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'pressid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const pressSlice = createSlice({
    name: 'press',
    initialState: {
        presss: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create press
            .addCase(createpress.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createpress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createpress.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update press
            .addCase(updatepress.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatepress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updatepress.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getpresss
            .addCase(getpress.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getpress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.presss = action.payload;
            })
            .addCase(getpress.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete presss
            .addCase(deletepresss.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletepresss.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.presss.data = state.presss.data.filter(presss => presss.pressid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletepresss.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default pressSlice.reducer;
